"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChoiceMemberList = void 0;
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const styled_components_1 = __importStar(require("styled-components"));
const common_1 = require("../../../../common");
const GlobalStateProvider_1 = require("../../../../GlobalStateProvider");
const SendMemberHeader_1 = require("./SendMemberHeader");
const ChoiceMembersTableStyled = styled_components_1.default.div `
	display: flex;
	flex-direction: column;
	gap: 14px;
	align-items: flex-start;
	justify-content: flex-start;
	flex-shrink: 0;
	position: relative;

	.disable {
		background-color: var(--color-grey-c, #e6e8ed);
	}

	.name {
		color: var(--color-black, #101010);
		text-align: left;
		font-family: var(--b4-font-family, 'Noto Sans KR', sans-serif);
		font-size: var(--b4-font-size, 14px);
		line-height: var(--b4-line-height, 28px);
		font-weight: var(--b4-font-weight, 400);
		position: relative;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
	}

	.dropdown {
		width: 100%;
	}

	.body-item {
		position: relative;
	}

	.dropdown-list {
		top: 48px;
	}

	.sms-choice-list {
		.scroll-content {
			display: flex;
			flex-direction: column;
			gap: 0px;
			align-items: flex-start;
			justify-content: flex-start;
			position: relative;
			max-height: 600px;
			overflow: auto;
		}
	}

	.paging {
		margin-top: 20px;
		gap: 10px;

		button {
			width: 18px;
			height: 18px;

			p {
				min-width: unset;
			}
		}
	}

	${props => (props.$isMobile ? mobileStyles : props.$isTablet ? tabletStyles : desktopStyles)}
`;
const mobileStyles = (0, styled_components_1.css) `
	.table-item-wrap {
		.body-item {
			width: unset;
		}
	}

	.sms-choice-list {
		display: flex;
		flex-direction: column;
		gap: 0px;
		align-items: flex-start;
		justify-content: flex-start;
		flex-shrink: 0;
		position: relative;
		overflow: hidden;
		flex: 1;

		.item {
			border-style: solid;
			border-color: var(--color-grey-c, #e6e8ed);
			border-width: 1px 0px 0px 0px;
			padding: 12px 0px 12px 0px;
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: flex-start;
			flex-shrink: 0;

			p {
				color: var(--color-black, #101010);
				text-align: left;
				font-family: var(--b4-font-family, 'Noto Sans KR', sans-serif);
				font-size: 12px;
				line-height: 150%;
				letter-spacing: -0.02em;
				font-weight: 400;
			}

			.grey {
				color: var(--color-grey-l, #83868a);
				font-size: var(--b4-font-size, 12px);
			}
		}
	}

	.table-header-item {
		padding-bottom: 10px;
	}

	.check-btn {
		padding: 8px 0px;
	}
`;
const tabletStyles = (0, styled_components_1.css) `
	background: var(--color-white, #ffffff);
	display: flex;
	flex-direction: column;
	gap: 14px;
	align-items: center;
	justify-content: flex-start;
	flex-shrink: 0;
	position: relative;
	min-width: 150px;
	flex: 1;

	.sms-choice-list {
		display: flex;
		flex-direction: column;
		gap: 0px;
		align-items: flex-start;
		justify-content: flex-start;
		position: relative;
		align-self: stretch;
		flex: 1;

		.table-header {
			background: var(--color-silver, #f3f4f8);
			border-style: solid;
			border-color: var(--color-grey-w, #b6bac0);
			border-width: 1px 0px 0px 0px;
			padding: 10px 16px 10px 16px;
			display: flex;
			flex-direction: row;
			gap: 6px;
			align-items: center;
			justify-content: flex-start;
			flex-shrink: 0;

			position: relative;
			text-align: left;
			font-family: var(--b4-font-family, 'Noto Sans KR', sans-serif);
			font-size: 12px;
			line-height: 150%;
			letter-spacing: -0.02em;
			font-weight: 400;
			position: relative;

			.table-header-item {
				min-width: unset !important;
				svg {
					width: 18px;
					min-width: unset;
				}
			}
		}

		.item {
			border-style: solid;
			border-color: var(--color-silver, #f3f4f8);
			border-width: 0px 0px 1px 0px;
			padding: 12px 16px 12px 16px;
			display: flex;
			flex-direction: row;
			gap: 6px;
			align-items: center;
			justify-content: flex-start;
			flex-shrink: 0;
			position: relative;

			color: var(--color-black, #101010);
			text-align: left;
			font-family: var(--b4-font-family, 'Noto Sans KR', sans-serif);
			font-size: 12px;
			line-height: 150%;
			letter-spacing: -0.02em;
			font-weight: 400;
			position: relative;

			.body-item {
				min-width: unset !important;
				.checkbox-item {
					svg {
						width: 18px;
						min-width: unset;
					}
				}
			}
		}
	}
`;
const desktopStyles = (0, styled_components_1.css) `
	background: var(--color-white, #ffffff);
	${props => !props.$isPopup &&
    (0, styled_components_1.css) `
			border-radius: 10px;
			border-style: solid;
			border-color: var(--color-grey-c, #e6e8ed);
			border-width: 1px;
			padding: 24px;
		`}

	display: flex;
	flex-direction: column;
	gap: 14px;
	align-items: center;
	justify-content: flex-start;
	flex-shrink: 0;
	position: relative;
	min-width: 215px;
	flex: 1;

	.sms-choice-list {
		display: flex;
		flex-direction: column;
		gap: 0px;
		align-items: flex-start;
		justify-content: flex-start;
		position: relative;
		align-self: stretch;
		flex: 1;

		.table-header {
			background: var(--color-silver, #f3f4f8);
			border-style: solid;
			border-color: var(--color-grey-w, #b6bac0);
			border-width: 1px 0px 0px 0px;
			padding: 10px 16px 10px 16px;
			display: flex;
			flex-direction: row;
			gap: 20px;
			align-items: center;
			justify-content: flex-start;
			flex-shrink: 0;

			position: relative;
			text-align: left;
			font-family: var(--b4-font-family, 'Noto Sans KR', sans-serif);
			font-size: var(--b4-font-size, 14px);
			line-height: var(--b4-line-height, 28px);
			letter-spacing: var(--b4-letter-spacing, -0.02em);
			font-weight: var(--b4-font-weight, 400);
			position: relative;
		}

		.item {
			border-style: solid;
			border-color: var(--color-silver, #f3f4f8);
			border-width: 0px 0px 1px 0px;
			padding: 12px 16px 12px 16px;
			display: flex;
			flex-direction: row;
			gap: 20px;
			align-items: center;
			justify-content: flex-start;
			flex-shrink: 0;
			position: relative;

			p {
				color: var(--color-black, #101010);
				text-align: left;
				font-family: var(--b4-font-family, 'Noto Sans KR', sans-serif);
				font-size: var(--b4-font-size, 14px);
				line-height: var(--b4-line-height, 28px);
				letter-spacing: var(--b4-letter-spacing, -0.02em);
				font-weight: var(--b4-font-weight, 400);
				position: relative;
			}
		}
	}
`;
exports.ChoiceMemberList = react_1.default.memo(({ memberSetting = "", checkedList, isNotChecked = false, memberList, noNumberData = [], setDeleteMemberList, isPopup, isNormal = true, isRegist = false, }) => {
    const { isDesktop, isTablet, isMobile } = (0, GlobalStateProvider_1.useGlobalState)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const count = 10;
    const [page, setPage] = (0, react_1.useState)(0);
    const [testData, setTestData] = (0, react_1.useState)([]);
    const [totalCount, setTotalCount] = (0, react_1.useState)(0);
    const [checkList, setCheckList] = (0, react_1.useState)([]);
    const [searchOption, setSearchOption] = (0, react_1.useState)('');
    const [defaultCheckMembers, setDefaultCheckMembers] = (0, react_1.useState)([]);
    (0, react_1.useEffect)(() => {
        if (memberList && memberList.length > 0) {
            let filteredList = memberList;
            if (searchOption) {
                filteredList = memberList.filter(i => i.data[0].toLowerCase().includes(searchOption) ||
                    i.data[1].toLowerCase().includes(searchOption) ||
                    i.data[2] && i.data[2].toLowerCase().includes(searchOption) ||
                    i.data[3] && i.data[3].toLowerCase().includes(searchOption) ||
                    i.data[4] && i.data[4].toLowerCase().includes(searchOption) ||
                    i.data[5] && i.data[5].toLowerCase().includes(searchOption));
            }
            const paginatedList = filteredList.length > 10
                ? filteredList.slice(page * count, page * count + count)
                : filteredList;
            setTestData(paginatedList);
            setTotalCount(filteredList.length);
        }
        else {
            setTestData([]);
            setTotalCount(0);
        }
    }, [memberList, searchOption, page, count]);
    (0, react_1.useEffect)(() => {
        if (checkList.length > 0) {
            const data = testData.filter(item => checkList.includes(item.id));
            setDeleteMemberList && setDeleteMemberList(data);
        }
        else {
            setDeleteMemberList && setDeleteMemberList([]);
        }
    }, [checkList]);
    (0, react_1.useEffect)(() => {
        if (checkedList && checkedList.length > 0) {
            setDefaultCheckMembers(checkedList);
        }
    }, [checkedList]);
    const handlerMoreData = (page) => {
        setPage(page);
    };
    const { headTitleList, tableReadDataKeys } = react_1.default.useMemo(() => {
        const headTitleList = [
            ...(!isMobile ? isNormal ?
                [
                    { title: 'nameId', space: 1, sort: false },
                    { title: 'phoneNumber', space: 2, sort: false },
                ] : [
                { title: 'nameId', space: 1, sort: false },
                { title: 'phoneNumber', space: 1, sort: false },
                { title: 'substitute1', space: 1, sort: false },
                { title: 'substitute2', space: 1, sort: false },
                { title: 'substitute3', space: 1, sort: false },
                { title: 'substitute4', space: 1, sort: false },
            ] : []),
        ];
        const tableReadDataKeys = isNormal ? [
            { title: 'nickname', space: 1, sort: false },
            { title: 'phone_number', space: 2, sort: false },
        ] : [
            { title: 'nickname', space: 1, sort: false },
            { title: 'phone_number', space: 1, sort: false },
            { title: 'substitute1', space: 1, sort: false },
            { title: 'substitute2', space: 1, sort: false },
            { title: 'substitute3', space: 1, sort: false },
            { title: 'substitute4', space: 1, sort: false },
        ];
        // useMemo에서 반환
        return { headTitleList, tableReadDataKeys };
    }, [isNormal, isMobile]);
    // 상단 레이아웃 검색 조건을 위한 action
    const handlerFilterList = (filter) => {
        const search = Object.values(filter);
        const searchTerm = search && search.length > 0 ? search[0] : undefined;
        setSearchOption(searchTerm);
    };
    const handlerClosePopup = () => {
        APP.eventManager.publish('TOGGLE_POPUP', undefined);
    };
    const handlerSetMembers = () => {
        const checkListMembers = memberList.filter(item => checkList.includes(item.id));
        const filteredCheckListMembers = checkListMembers.filter(item => !noNumberData.some(noNumItem => noNumItem.id === item.id));
        APP.eventManager.publish('ADD_SELECTED_MEMBERS', {
            members: filteredCheckListMembers,
            setting: memberSetting,
        });
        APP.eventManager.publish('TOGGLE_POPUP', undefined);
    };
    const renderTitle = (0, react_1.useMemo)(() => {
        return (react_1.default.createElement(SendMemberHeader_1.SendMemberHeader, { handlerFilterList: handlerFilterList, totalTableList: memberList && memberList.length, isReceiver: true, isRegist: isRegist, isPopup: isPopup }));
    }, [handlerFilterList, memberList, isPopup, isRegist]);
    const formatPhoneNumber = (phone) => {
        if (!phone)
            return "-";
        return phone.replace(/^(\d{3})(\d{4})(\d{4})$/, "$1-$2-$3");
    };
    const renderItem = (item, styles) => {
        if (isMobile)
            return tableReadDataKeys.map((headItem, index) => (react_1.default.createElement("p", { className: "overText2", key: index },
                index === 1 ? formatPhoneNumber(item.data[index]) : item.data[index] || "-",
                index < tableReadDataKeys.length - 1 && " / ")));
        return tableReadDataKeys.map((headItem, index) => (react_1.default.createElement("div", { key: headItem.title, className: "body-item", style: {
                flex: !isMobile && headItem.space,
                ...styles?.bodyItem,
            } },
            react_1.default.createElement("p", { className: "overText2" }, index === 1 ? formatPhoneNumber(item.data[index]) : item.data[index] || "-"))));
    };
    return (react_1.default.createElement(ChoiceMembersTableStyled, { "$isMobile": isMobile, "$isTablet": isTablet, "$isPopup": isPopup, className: "user-list" },
        renderTitle,
        react_1.default.createElement(common_1.Table, { className: "sms-choice-list", forceShowheader: true, showCheckBox: isNotChecked ? false : true, defaultCheckList: defaultCheckMembers, disableIdList: noNumberData.map(item => item.id), isInfinite: false, data: testData, totalCount: totalCount, page: page, showCount: count, sortDefault: "id", headTitleList: headTitleList, renderItem: renderItem, handlerCheckList: setCheckList, handlerMoreData: handlerMoreData, isKeepChecked: true, isSMS: true, renderGuidItem: isNotChecked ? undefined : react_1.default.createElement(react_1.default.Fragment, null), padding: false }),
        isPopup && !isNotChecked && (react_1.default.createElement("div", { className: "btn-container", style: { width: "100%", justifyContent: "center" } },
            react_1.default.createElement(common_1.Button, { className: "btn_line_grey xmd", text: t('common.cancel'), onClick: handlerClosePopup }),
            react_1.default.createElement(common_1.Button, { className: "btn_default xmd", text: t('common.regist'), onClick: handlerSetMembers })))));
});
